import { useTranslation } from 'react-i18next'

import { ArrowRightIcon, QuestionIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SupportFooter = ({ supportDashboardUrl, showMenu }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!supportDashboardUrl) {
    return null
  }

  return (
    <Styles.Container expanded={showMenu}>
      <Styles.IconRow expanded={showMenu} data-testid="support-footer-icon">
        <QuestionIcon size={24} color={theme.colors.outline.default} />
      </Styles.IconRow>
      <Styles.ExpandedCard expanded={showMenu}>
        <Styles.CardHeader>
          <QuestionIcon size={24} color={theme.colors.outline.default} />
          <Text type="titleS" color={theme.colors.outline.default}>
            {t('¿Necesitas ayuda?')}
          </Text>
        </Styles.CardHeader>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {t('Usa nuestro panel de soporte para enviar solicitudes y hacer seguimiento de su estado')}
        </Text>
        <Styles.SupportLink href={supportDashboardUrl} target="_blank" rel="noopener noreferrer">
          <Text type="linkS" color={theme.colors.outline.default}>
            {t('Acceder al panel de soporte')}
          </Text>
          <ArrowRightIcon size="16" color={theme.colors.outline.default} />
        </Styles.SupportLink>
      </Styles.ExpandedCard>
    </Styles.Container>
  )
}

export default SupportFooter
